const topics = [
  { tag: '古风耽美', heat: '826万', color: 'primary' },
  { tag: '现代都市', heat: '715万', color: 'accent' },
  { tag: '校园青春', heat: '634万', color: 'secondary' },
  { tag: '强强对决', heat: '512万', color: 'primary' },
  { tag: '先婚后爱', heat: '487万', color: 'accent' },
  { tag: '穿越重生', heat: '456万', color: 'secondary' },
  { tag: 'ABO设定', heat: '389万', color: 'primary' },
  { tag: '破镜重圆', heat: '342万', color: 'accent' },
  { tag: '仙侠修真', heat: '315万', color: 'secondary' },
];

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">耽美漫画爱好者最关注的热门标签与话题讨论</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.tag}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap ${colorMap[topic.color]}`}
            >
              <span>{topic.tag}</span>
              <span className="text-xs opacity-70">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}